import React, { createContext, useState, useContext, useEffect } from 'react';
import { authAPI } from '../../services/api';

const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const userData = localStorage.getItem('user');
        
        if (token && userData) {
            setUser(JSON.parse(userData));
        }
        setLoading(false);
    }, []);

    const login = async (username, password) => {
        try {
            setError(null);
            const response = await authAPI.login({ username, password });
            
            // The response structure from your backend
            const { token, dashboardUrl, ...userData } = response.data;
            
            // Store both token and user data
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(userData));
            
            setUser(userData);
            
            // Return the expected format for the Login component
            return { 
                success: true, 
                dashboardUrl: dashboardUrl || (userData.role === 'user' ? '/user/dashboard' : '/admin/dashboard')
            };
        } catch (error) {
            const errorMsg = error.response?.data?.message || 'Login failed';
            setError(errorMsg);
            return { success: false, error: errorMsg };
        }
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
    };

    const value = {
        user,
        loading,
        error,
        login,
        logout,
        isAuthenticated: !!user,
        isAdmin: user?.role === 'admin',
        isSuperMaster: user?.role === 'super_master',
        isMaster: user?.role === 'master',
        isAgent: user?.role === 'agent',
        isUser: user?.role === 'user'
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};